import {Box, Heading} from "@chakra-ui/react";
import React from "react";

export interface TitledPageProps {
    title: string | React.ReactNode;
}

const TitledPage: React.FC<TitledPageProps> = ({children, title}) => (
    <Box>
        <Heading as="h1" size="2xl" color="primary.800" marginBottom=".3em" paddingBottom=".2em" borderBottomWidth="1px" borderBottomStyle="solid" borderBottomColor="primary.600">{title}</Heading>
        {children}
    </Box>
)

export default TitledPage